import React from 'react';
import * as mobxReact from 'mobx-react';
import { injectIntl, IntlShape } from 'react-intl';
import { CommonPopupBodyFooterLayout } from '../../../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../../../global/sub-window/common/common-close-sub-window-buttons';
import { RichTextEditor } from '../../../../global/rich-text-editor';
import { configForMarkdown } from '../../../../global/rich-text-editor/CKEditor.config';
import { FormField } from '../../../../global/form/form-field/form-field';
import AgentMemoryFormVM from './agent-memory-form.viewmodel';
import './agent-memory-form.scss';
import { AGENT_MEMORY_IS_BEING_SAVED_TEXT, AGENT_MEMORY_LABEL_TEXT } from './agent-memory-form.text';
import { CANCEL_TEXT, DONE_TEXT } from '../../../../../constants/common-labels.constants';

interface IAgentMemoryFormPresentation {
    vm: AgentMemoryFormVM;
    intl: IntlShape;
}

const AgentMemoryFormPresentation = injectIntl(mobxReact.observer(({ vm, intl }: IAgentMemoryFormPresentation) => {
    return (
        <CommonPopupBodyFooterLayout
            className='agent-memory-popup-body'
            body={(
                <form className='oe-form agent-memory-form' onSubmit={e => {
                    e.preventDefault();
                    vm.formSubmitAction();
                }}>
                    <div className='oe-form__body'>
                        <FormField label={intl.formatMessage(AGENT_MEMORY_LABEL_TEXT)}>
                            <RichTextEditor
                                id='event-agent-memory'
                                value={vm.agentMemory}
                                className='agent-memory-editor'
                                config={configForMarkdown}
                                onChange={(event, editor) => vm.setAgentMemory(editor.getData())}
                                readonly={vm.loadFailed}
                                validationError={vm.agentMemoryLengthError}
                            />
                        </FormField>
                        {vm.lastModifiedLabel && <p className='agent-memory-form__last-modified'>{vm.lastModifiedLabel}</p>}
                    </div>
                </form>
            )}
            footer={
                <>
                    {vm.isSaving && intl.formatMessage(AGENT_MEMORY_IS_BEING_SAVED_TEXT)}
                    <div className='buttons-block buttons-block--from-right'>
                        <DefaultCloseSubWindowButton
                            text={intl.formatMessage(DONE_TEXT)}
                            onClick={vm.formSubmitAction}
                            modifier={['fat', 'confirm-safe']}
                            disabled={vm.loadFailed || !!vm.agentMemoryLengthError || vm.isSaving}
                        />
                        <DefaultCloseSubWindowButton text={intl.formatMessage(CANCEL_TEXT)} />
                    </div>
                </>
            }
        />
    );
}));

export { AgentMemoryFormPresentation };
